import {
    SET_GLOBAL_LOADER
 } from "./GlobalLoaderType";
 
 export const setGlobalLoader = (loader: any) => ({
     type: SET_GLOBAL_LOADER,
     loader: loader,
 }); 